import BotMenuPage from './pages/BotMenu.vue'
import FormSurveyQuestionsField from './fields/Form/SurveyQuestionsField.vue'
import DetailSurveyQuestionsField from './fields/Detail/SurveyQuestionsField.vue'

/**
 * Register telegram-module Nova Vue pages and fields.
 *
 * @param {import('vue').App} app
 */
const telegramModuleSetup = (app) => {
  app.inertia('Telegram.BotMenu', BotMenuPage)

  app.component('form-survey-questions-field', FormSurveyQuestionsField)
  app.component('detail-survey-questions-field', DetailSurveyQuestionsField)
}

export { telegramModuleSetup }
